window.Products.Clothing.BabyLeggings1year = function() {};

window.Products.Clothing.BabyLeggings1year.inherits(window.Products.Clothing.BabyLeggings);
window.Products.Clothing.BabyLeggings1year.has_3d = true;
window.Products.Clothing.BabyLeggings1year.id = '27-1year';
window.Products.Clothing.BabyLeggings1year.saveId = 27;
window.Products.Clothing.BabyLeggings1year.slug = 'baby-leggings-1year';
window.Products.Clothing.BabyLeggings1year.dpi = 150;